module.exports = __webpack_public_path__ + "img/pos_sortir.9f29aed2.png";